import React, { useState, useEffect } from "react";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from "./CheckoutForm";
import { format } from 'date-fns';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`);

export default function PaymentPage() {
  // const options = {
  //     mode: 'payment',
  //     amount: 1099,
  //     currency: 'usd',        
  //     appearance: {
  //         /*...*/
  //     }
  // };

  const navigate = useNavigate();

  const [clientSecret, setClientSecret] = useState("");
  const [databaseId, setDatebaseid] = useState("");
  const [alldata, setAllData] = useState("");
  const [stripeData, setStripeData] = useState("");

  var addPayment = localStorage.getItem('add_payment');
  const showTime = format(new Date(), 'MMddyyyyHis');

  var addPaymentObject = JSON.parse(addPayment);
  if (!addPayment) {
    navigate('/advertisement');
  }
  useEffect(() => {

    console.log('order_ids', addPaymentObject)
    axios.post(`${process.env.REACT_APP_API_URL}stripe.php`, { datebaseid: addPaymentObject, action: "adAddPayment" })
      .then((response) => {
        if (response.data.status === true) {
          setClientSecret(response.data.clientSecret);
          setDatebaseid(response.data.datebaseid);
          setStripeData(response.data.data);
          console.log('stripeData',stripeData)
        } else {
          navigate('/advertisement');
          Swal.fire({
            icon: 'error',
            title: "Advertisement not found",
          });
        }
      })

      .catch((error) => {
        console.error('Error fetching client secret:', error);
      });
  }, [addPaymentObject]);

  useEffect(() => {
    if (databaseId !== '') {
      axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetAdbyId', id: databaseId })
        .then((response) => {
          setAllData(response.data.data)
        })
        .catch((error) => {
          console.error('Error fetching client secret:', error);
        });
    }
  }, [databaseId]);

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };


  return (
    <>

      <section className="page-content half-map sec-padding">
        <div className="container">
          <div className="sec-title row justify-content-center">
            <h3>Payment</h3>
          </div>
          <div className="col-md-12 mx-auto">
            <div className="row AddressView">
              <div className="col-md-6">
                <h3>Advertisement Details</h3>
                {alldata &&
                  <>
                    <img width={150}
                      className="garage__image"
                      src={`${alldata.picture ? `${process.env.REACT_APP_UPLOAD_URL + alldata.picture}?time=${showTime}` : `${process.env.REACT_APP_UPLOAD_URL + 'images/images.png'}`}`}
                      alt='imagesURL'
                      style={{ transform: `rotate(${alldata.pictureA ? alldata.pictureA : 0}deg)` }}
                    />

                    <table className="table">
                      <tbody>
                        <tr>
                          <th>Total Pay</th>
                          <td>${alldata.TotalPay}</td>
                        </tr>
                        <tr>
                          <th>Business Name</th>
                          <td>{alldata.businessName}</td>
                        </tr>
                        <tr>
                          <th>Business URL</th>
                          <td>{alldata.businessURL}</td>
                        </tr>
                        <tr>
                          <th>Business License</th>
                          <td>{alldata.businessLicense}</td>
                        </tr>
                        <tr>
                          <th>Start Date</th>
                          <td>{stripeData.start_date && stripeData.start_date !== '0000-00-00' ? format(new Date(stripeData.start_date || null), 'MM/dd/yyyy') : ''}</td>
                        </tr>
                        <tr>
                          <th>End Date</th>
                          <td>{stripeData.end_date && stripeData.end_date !== '0000-00-00' ? format(new Date(stripeData.end_date || null), 'MM/dd/yyyy') : ''}</td>
                        </tr>
                        <tr>
                          <th>ZipCodes</th>
                          <td>
                            {stripeData.zipcodes && stripeData.zipcodes}</td>
                        </tr>
                        <tr>
                          <th>PaymentType</th>
                          <td>{alldata.PaymentType === 'YearlyBilling' ? 'Annual' : 'Monthly'}</td>
                        </tr>
                        <tr>
                          <th>Approve Status</th>
                          <td>
                            {alldata.PaymentStatus === 0
                              ? 'Payment Pending'
                              : alldata.approveStatus === 0
                                ? 'Approval Pending'
                                : alldata.approveStatus === 1
                                  ? 'Approved'
                                  : alldata.approveStatus === 2
                                    ? 'Disapproved'
                                    : ''}


                          </td>
                        </tr>
                        <tr>
                          <th>User Status</th>
                          <td>{alldata.userStatus === 1 ? 'Enabled' : 'Disabled'}</td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                }
              </div>
              <div className="col-md-6">
                {/* <Elements stripe={stripePromise} options={options}>
                                    <CheckoutForm />
                                </Elements> */}
                {clientSecret && (
                  <Elements options={options} stripe={stripePromise}>
                    <CheckoutForm cancelbtn={alldata.type === 'renew' ? true : false} callbackUrl={'success'} />
                  </Elements>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )

}
